// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__kQjTm","container":"Hero_container__yAoqX","flaskWrapper":"Hero_flaskWrapper__ZDmsZ","potionWrapper":"Hero_potionWrapper__X8OO3","potion":"Hero_potion__xl7qc"};